import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import toasts from "@common/lib/toast";
import { type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { localStateSelector } from "./selectors";
import { type MemberProfile } from "./types";

export enum Actions {
  InitBegin = "MEMBER_PROFILE_INIT_BEGIN",
  InitFailure = "MEMBER_PROFILE_INIT_FAILURE",
  InitSuccess = "MEMBER_PROFILE_INIT_SUCCESS"
}

export type InitBeginActionData = EntityRef;
export interface InitSuccessActionData {
  profile?: MemberProfile.Profile;
}
export const _init = initAction<
  BaseAppState,
  InitBeginActionData,
  MemberProfile.Api.InitResponse,
  InitSuccessActionData
>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo, {});
  }
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (localState.status === Status.None) {
    dispatch(_init(args));
  }
};

export const resetPassword =
  (ref: EntityRef, password: string) =>
  async (dispatch: Dispatch<any>, getState: () => BaseAppState): Promise<any> => {
    const state = getState();
    const apiInfo = makeModuleApiInfoSelector()(state, ref);
    const res = await api.resetPassword(apiInfo, { password });
    if (res.error) throw new Error(res.error);
    if (!res.response) throw new Error("Unexpected error has occurred");

    toasts.saved();
  };
